import { Nullable } from '@mobalytics/shared';
import { AllowedActionsT, ChangeActionT, CreateActionT, RenewActionT, type UserActionsUnionT } from '../payment.types';

export const processAllowedActions = (allowedActions: Nullable<UserActionsUnionT[]>): AllowedActionsT => {
  const createAction = allowedActions?.find(
    (it) => it.__typename === 'TreasuryPaymentCustomerActionCreateSubscription' && it.isAllowed
  ) as Nullable<CreateActionT>;
  const changeAction = allowedActions?.find(
    (it) => it.__typename === 'TreasuryPaymentCustomerActionChangeSubscription' && it.isAllowed
  ) as Nullable<ChangeActionT>;
  const renewAction = allowedActions?.find(
    (it) => it.__typename === 'TreasuryPaymentCustomerActionRenewSubscription' && it.isAllowed
  ) as Nullable<RenewActionT>;
  return {
    create: !!createAction,
    change: !!changeAction,
    renew: !!renewAction,
  };
};
